import { ehUrlNavegavelSegura } from '@/shared/utils/urlSegura';

import type { PacoteDosAutos } from '../types/baixarProcesso.types';

/**
 * A URL do PDF do servidor, quando o pacote já tem arquivo para baixar agora. Com a ciência dos
 * anexos pendente, não há o que baixar: o servidor já não manda a URL, e a tela não depende só
 * disso — o link do e-mail não pode baixar sem a ciência.
 */
export function urlDoPacoteBaixavel(pacote: PacoteDosAutos): string | null {
  if (pacote.status !== 'PRONTO' || pacote.cienciaPendente || !pacote.urlDownload) return null;
  return ehUrlNavegavelSegura(pacote.urlDownload) ? pacote.urlDownload : null;
}

/**
 * Baixa sem clique, para quem chegou pelo botão do e-mail. `window.open` sem gesto do usuário é
 * barrado pelo bloqueador de pop-up; navegar na própria aba não tira a pessoa da tela porque a
 * URL assinada responde `Content-Disposition: attachment` — o navegador só salva o arquivo.
 */
export function iniciarDownload(url: string): void {
  window.location.assign(url);
}
